import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTitleComponent } from './page-title/page-title.component';
import { SearchComponent } from './search/search.component';
import { NoDataComponent } from './no-data/no-data.component';
import { MiniLoadComponent } from './mini-load/mini-load.component';

@NgModule({
  declarations: [PageTitleComponent, SearchComponent, NoDataComponent, MiniLoadComponent],
  imports: [CommonModule],
  exports: [PageTitleComponent, SearchComponent, NoDataComponent, MiniLoadComponent],
})
export class ComponentsModule {}
